import { createAuthStore, type AuthUser } from '@/shared/lib/auth-store-factory';

const ALLOWED_USER_TYPES = ['professional', 'doctor'];

const isUserTypeAllowed = (type?: string): boolean => {
  if (!type) return false;
  return ALLOWED_USER_TYPES.includes(type);
};

export const useUserAuthStore = createAuthStore({
  storageKey: 'examfy-user-auth-storage',
  version: 2,
  logPrefix: 'Auth',
  validateUser: (user: AuthUser) => isUserTypeAllowed(user.type),
});

export type { AuthUser as User };
export { isUserTypeAllowed };
